import { clientPortalApi } from 'src/api';
import { AxiosRequestConfig } from 'axios';
import { UserPermissionResponse } from 'src/types';

export const getPermissionsAssignedToUser = (userId: string, config: AxiosRequestConfig = {}) =>
  clientPortalApi.get<UserPermissionResponse[]>(`/api/v1/permissions/${userId}`, config);
